import React from 'react';
import {
  CreditCardIcon,
  AmexCardIcon,
  VisaCardIcon,
  MasterCardCardIcon,
  JcbCardIcon,
  DinersCardIcon,
  DiscoverCardIcon,
  UnionPayCardIcon,
} from 'assets/icons';
import styled, { css } from 'styled-components/macro';

export const getCardBrandIcon = (cardBrand: string, height?: string, width?: string): JSX.Element => {
  switch (cardBrand.toLowerCase()) {
    case 'visa':
      return <StyledVisaIcon height={height} width={width} />;
    case 'mastercard':
      return <StyledMastercardIcon height={height} width={width} />;
    case 'american express':
    case 'amex':
      return <StyledAmexIcon height={height} width={width} />;
    case 'discover':
      return <StyledDiscoverIcon height={height} width={width} />;
    case 'jcb':
      return <StyledJCBIcon height={height} width={width} />;
    case 'diners club':
    case 'diners':
      return <StyledDinersIcon height={height} width={width} />;
    case 'unionpay':
      return <StyledUnionPayIcon height={height} width={width} />;
    default:
      return <StyledCreditCardIcon height={height} width={width} />;
  }
};

const IconStyles = css<{ height?: string; width?: string }>`
  width: ${({ width }): string => (width ? width : '50%')};
  height: ${({ height }): string => (height ? height : '50%')};
`;

const StyledAmexIcon = styled(AmexCardIcon)`
  ${IconStyles}
`;

const StyledVisaIcon = styled(VisaCardIcon)`
  ${IconStyles}
`;

const StyledMastercardIcon = styled(MasterCardCardIcon)`
  ${IconStyles}
`;

const StyledDiscoverIcon = styled(DiscoverCardIcon)`
  ${IconStyles}
`;

const StyledJCBIcon = styled(JcbCardIcon)`
  ${IconStyles}
`;

const StyledDinersIcon = styled(DinersCardIcon)`
  ${IconStyles}
`;

const StyledUnionPayIcon = styled(UnionPayCardIcon)`
  ${IconStyles}
`;

const StyledCreditCardIcon = styled(CreditCardIcon)`
  ${IconStyles}
`;
